import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../AuthService';
import 'bootstrap/dist/css/bootstrap.min.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await AuthService.login({ username, password });
            if (response.data.token !== 'Invalid credentials') {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('userType', response.data.userType);
                if(response.data.userType === "ADMIN") {
                    navigate('/dashboard');
                } else {
                    navigate('/farmers');
                }
            } else {
                setMessage('Invalid credentials');
            }
        } catch (error) {
            setMessage('Invalid credentialss');
        }
    };

    return (
        <>
            <div className="login">
                <h1> VisitLog German Genetic </h1>
            </div>

            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-header"> Anmeldeform </div>
                            <div className="card-body">
                                { message && <div className="alert alert-danger">{message}</div> }
                                <form onSubmit={handleLogin}>
                                    <div className="form-group">
                                        <label> Benutzer </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label> Kennwort </label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </div>
                                    <br/>
                                    <button type="submit" className="btn btn-primary">Login</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
